import { render, staticRenderFns } from "./landUpdate.vue?vue&type=template&id=384d9628&scoped=true&"
import script from "./landUpdate.vue?vue&type=script&lang=js&"
export * from "./landUpdate.vue?vue&type=script&lang=js&"
import style0 from "./landUpdate.vue?vue&type=style&index=0&id=384d9628&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d9628",
  null
  
)

export default component.exports